/**
 * Decorative tennis court seen from above.
 * White lines on transparent background so it can overlay any color.
 * Placed as a full-bleed absolute decoration in the hero.
 */
export default function CourtLines({ className = "" }) {
  return (
    <svg
      viewBox="0 0 800 400"
      preserveAspectRatio="none"
      className={className}
      aria-hidden="true"
    >
      {/* Doubles boundary */}
      <rect x="40" y="60" width="720" height="280" fill="none" stroke="white" strokeWidth="2.5" />

      {/* Service lines (vertical, parallel to baselines) */}
      <line x1="220" y1="60" x2="220" y2="340" stroke="white" strokeWidth="2" />
      <line x1="580" y1="60" x2="580" y2="340" stroke="white" strokeWidth="2" />

      {/* Center service line (only between service lines, splits service boxes) */}
      <line x1="220" y1="200" x2="580" y2="200" stroke="white" strokeWidth="2" />

      {/* Net */}
      <line x1="400" y1="40" x2="400" y2="360" stroke="white" strokeWidth="2.5" strokeDasharray="6 4" />

      {/* Center marks on baselines */}
      <line x1="40" y1="200" x2="60" y2="200" stroke="white" strokeWidth="2" />
      <line x1="740" y1="200" x2="760" y2="200" stroke="white" strokeWidth="2" />
    </svg>
  );
}
